<template>
  <div :class="classes">
      <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber"
      :page-size="pageSize" :current-page="currentPage" isAddPageToRouter v-loading="loading">
      <wt-table :list="tableData">
          <template>
              <el-table-column label="优惠劵名称">
                  <template slot-scope="scope">
                      {{scope.row.couponData&&scope.row.couponData.name}}
                  </template>
              </el-table-column>
              <el-table-column label="优惠形式">
                  <template slot-scope="scope">
                      {{scope.row.discountType}}
                  </template>
              </el-table-column>
              <el-table-column label="内容">
                  <template slot-scope="scope">
                    <div>{{scope.row.discount}}</div>
                    <div>{{scope.row.thresholdOfAmount?'满'+scope.row.thresholdOfAmount+'元可使用':'无门槛'}}</div>
                  </template>
              </el-table-column>
              <!-- <el-table-column label="发放总量">
                  <template slot-scope="scope">
                      {{scope.row.amount}}
                  </template>
              </el-table-column> -->
              <el-table-column label="已领取/剩余">
                  <template slot-scope="scope">
                      {{scope.row.getAmount+'/'+ (hasLimit(scope.row) ? scope.row.surplusAmount : '不限')}}
                  </template>
                </el-table-column>
              <el-table-column label="已使用">
                  <template slot-scope="scope">
                      {{scope.row.usedAmount}}
                  </template>
              </el-table-column>
              <el-table-column label="有效期" min-width="100">
                  <template slot-scope="scope">
                      <div>{{scope.row.startTime}} 至</div>
                      <div>{{scope.row.endTime}}</div>
                  </template>
              </el-table-column>
              <el-table-column label="发布方式">
                  <template slot-scope="scope">
                      {{scope.row.publishType}}
                  </template>
              </el-table-column>
              <el-table-column label="状态">
                  <template slot-scope="scope">
                      {{scope.row.coupon_status}}
                  </template>
              </el-table-column>
              <template v-if="auditStatus">
                  <el-table-column label="申请人">
                      <template slot-scope="scope">
                      {{scope.row.editorInfo&&scope.row.editorInfo.operatorName}}
                      </template>
                  </el-table-column>
                  <el-table-column v-if="AUDITED"  label="审批人">
                      <template slot-scope="scope">
                      {{scope.row.auditInfo&&scope.row.auditInfo.operatorName}}
                      </template>
                  </el-table-column>
              </template>
              <slot/>
          </template>
      </wt-table>
      </wt-paged-table>
  </div>
</template>

<script>
import { couponTypeHasLimit } from 'json/mall-options'
// 组件class前缀
const prefixCls = 'pt-coupon-table'

export default {
  name: 'pt-coupon-table',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    // 优惠劵状态为已审核
    AUDITED () {
      return this.auditStatus === 'AUDITED'
    }
  },
  props: {
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    getGoodsList: {
      type: Function
    },
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    currentPage: {
      type: Number,
      default: 0
    },
    auditStatus: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      table_data: this.tableData
    }
  },
  methods: {
    getTableData (page, next) {
      this.$emit('couponList', page, next)
    },
    hasLimit (row) {
      return couponTypeHasLimit(row)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
:global
.pt-coupon-table{
.el-button{
    margin-right: 10px;
    +.el-button{
        margin-left: 0
    }
}
}
</style>
